namespace InvData {

    export enum PropertyTypeIds {
        String = 1,
        Integer = 2,
        Boolean = 3,
        Decimal = 4,
        Date = 5,
        LongText = 6,
        Html = 7,
        EntityRef = 8,
        TagRef = 9,
        InvestmentRef = 10,
        TransactionRef = 11,
        ContactRef = 12,
        NoteRef = 13,
        Url = 14,
        UserRef = 15,
        Currency = 16,
        ManagerRef = 17
    }

}

namespace InvData.PropertyTypeIds {

    export function getNameForPropertyTypeId(id: string) {
        for (var i in this) {
            if (typeof this[i] == "number") {
                if (this[i] == id) {
                    return i;
                }
            }
        }
    }

}